import React from "react";
import { Button, FormGroup, Icon, Input, Notification } from "xsolla-uikit";
import PAContentBlock from "../PAContentBlock";
import SwitchExample from "../SwitchExample";
import "../PAlauncher.css";













export default function PAloginSettings() {
  return (
    <div>
      <PAContentBlock title="General Settings" border="lg">
        {/* <FormGroup border="lg"> */}

        <FormGroup label="Login name" tooltip="Some tooltip">
          <Input
            input={{
              // name: 'with-icon',
              value: "Test Login"
            }}
            offset="right"
            extra={
              <Icon
                name="edit"
                hoverable={true}
                // onClick={e => this.handeCurrDel(this.id, e)}
              />
            }
          />
        </FormGroup>

        <FormGroup label="Secret key" tooltip="Secret key is" indentation="lg">
          <div className="l_flex">
            <div className="l_flex l_flex--grow">
              <Input
                className="l_flex l_flex--grow"
                style={{ width: "100%" }}
                input={{
                  // name: 'with-icon',
                  value:
                    "••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••"
                }}
                offset="right"
                extra={
                  <Icon
                    name="show"
                    hoverable={true}
                    // onClick={e => this.handeCurrDel(this.id, e)}
                  />
                }
              />
            </div>
            <div className="l_flex l_flex--l16">
              <Button appearance="square">
                <Icon name="copy" />
              </Button>
            </div>
          </div>
        </FormGroup>

        <FormGroup>
          <Notification status="info" size="md">
            View the{" "}
            <a href="https://developers.xsolla.com/doc/login/" target="_blank">
              guide
            </a>{" "}
            to set up Login correctly.
          </Notification>
        </FormGroup>

        {/* </FormGroup> */}
      </PAContentBlock>

      <PAContentBlock title="Connected sites and launchers" border="lg">
        <FormGroup indentation="lg">
          <FormGroup label="Websites to connect Login to" indentation="sm">
            <Input
              input={{
                // name: 'with-icon',
                value: "mysite.com"
              }}
              offset="right"
              extra={
                <Icon
                  name="delete"
                  hoverable={true}
                  // onClick={e => this.handeCurrDel(this.id, e)}
                />
              }
            />
          </FormGroup>

          <FormGroup label="" indentation="sm">
            <div className="add-field-button add-field-button__container">
              <span>Add website</span>
              <i
                className="xsui-icon xsui-icon-add-circle"
                style={{ fontSize: 24, color: "rgb(0, 118, 255)" }}
              />
            </div>
          </FormGroup>
        </FormGroup>

        <FormGroup label="Launchers to connect Login to" indentation="lg">
          <FormGroup label="" indentation="sm">
            <div className="add-field-button add-field-button__container">
              <span>Add launcher</span>
              <i
                className="xsui-icon xsui-icon-add-circle"
                style={{ fontSize: 24, color: "rgb(0, 118, 255)" }}
              />
            </div>
          </FormGroup>
        </FormGroup>
      </PAContentBlock>

      <PAContentBlock title="Authentication" border={false}>
        <FormGroup border="md" indentation="lg">
          <SwitchExample
            value={false}
            label="Sign in via username/password"
            tooltip="1"
          />
        </FormGroup>

        <FormGroup border="md" indentation="lg">
          <SwitchExample value={false} label="Sign up" tooltip="1" />
        </FormGroup>

        <FormGroup indentation="md">
          <SwitchExample value={false} label="Activation with a key">
            <div className="l_flex">
              <div className="l_flex l_flex--grow">
                <Input
                  input={{
                    value: "1440"
                  }}
                />
              </div>
              <div className="l_flex l_flex--l16">JWT expiration, minutes</div>
            </div>
          </SwitchExample>
        </FormGroup>
      </PAContentBlock>

      <PAContentBlock title="Password recovery" indentation="lg" />
    </div>
  );
}
